export default __webpack_public_path__ + "static/5-4--c4fe051f7c0d7f3f63f92b73653f43c1.png";